module.exports = __webpack_public_path__ + "img/sensor-details-poster.6223eb2f.jpg";